export default __webpack_public_path__ + "static/media/ic-reports-dark.e3a738fd.svg";